<template>
  <div class="grid grid-cols-12 gap-4">
    <div class="col-span-3">
      <vxe-select v-model="currentValue.City" transfer @change="changeCity($event.value)" placeholder="選擇縣市">
        <vxe-option v-for="(item, index) in cities" :label="item" :value="item" :key="'city-' + index"></vxe-option>
      </vxe-select>
    </div>
    <div class="col-span-3">
      <vxe-select v-model="currentValue.DistrictDisplay" transfer @change="updateValue" placeholder="選擇區域">
        <vxe-option v-for="(item, index) in districts" :label="item" :value="item" :key="'district-' + index">
        </vxe-option>
      </vxe-select>
    </div>
    <div class="col-span-6">
      <vxe-input v-model="currentValue.Line" @change="updateValue" placeholder="填寫地址"></vxe-input>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, ref, PropType, watch } from 'vue'
import Cloudfun from '@cloudfun/core'

interface PostalCode {
  City: string;
  Code: string;
  District: string;
}

interface Address {
  City: string;
  PostalCode: string;
  District: string;
  DistrictDisplay?: string;
  Line: string;
}

export default defineComponent({
  name: "AddressSelectBox",
  props: {
    modelValue: Object as PropType<Address>
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const postalCodes: PostalCode[] = (Cloudfun.current?.enums as any).PostalCodes;
    const cities = new Set([...postalCodes.map(e => e.City)]);
    const districts = ref<string[]>([]);
    const currentValue = ref<Address>({ City: "", PostalCode: "", District: "", DistrictDisplay: "", Line: "" });

    const changeCity = (value: string) => {
      districts.value = postalCodes.filter(e => e.City === value).map(e => e.Code + " " + e.District);
      currentValue.value.DistrictDisplay = "";
    }

    watch(() => props.modelValue, (val, oldVal) => {
      if (!val) return;
      currentValue.value.City = val.City || "";
      changeCity(currentValue.value.City);
      currentValue.value.DistrictDisplay = val.PostalCode && val.District ? val.PostalCode + " " + val.District : "";
      currentValue.value.Line = val.Line || "";
    }, { immediate: true });

    const updateValue = () => {
      if (!currentValue.value.City || !currentValue.value.DistrictDisplay || !currentValue.value.Line) return;
      const codes = currentValue.value.DistrictDisplay.split(' ');
      const model: Address = {
        City: currentValue.value.City,
        District: codes[1],
        PostalCode: codes[0],
        Line: currentValue.value.Line
      }
      emit("update:modelValue", model);
    }
    return {
      currentValue,
      changeCity,
      cities,
      districts,
      updateValue
    }
  }
})
</script>
